<template>
    <div class="intro">
        <div class="bg-verde">
            <div class="conteudo">
                <label data-aos="fade-right" data-aos-duration="1000" class="t1">Planti. é o melhor aplicativo de troca e vendas de plantas.</label>
                <label data-aos="fade-right" data-aos-duration="1000" class="t2">Crie um perfil social, compartilhe fotos de suas plantas, anuncie para troca ou venda e encontre outros amantes de plantas.</label>
                <a href="https://apps.apple.com/br/app/planti/id1533612038" target="_blank"><img data-aos="fade-right" data-aos-duration="1000" class="loja1" src="../../assets/images/app-store.svg" alt=""></a>
                <a href="https://play.google.com/store/apps/details?id=com.misie.planti" target="_blank"><img data-aos="fade-right" data-aos-duration="1000" class="loja2" src="../../assets/images/google-play.svg" alt=""></a>
                <img data-aos="fade-left" data-aos-duration="1000" class="celular" src="../../assets/images/celular1.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Intro',
}
</script>

<style scoped lang="scss">
.intro{
    position: relative;
}
.conteudo{
    position: relative;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    max-width: 1300px;
}

.bg-verde{
    position: relative;
    width: 100%;
    height: 620px;
    background: linear-gradient(258.32deg, #93F9B9 0%, #1D976C 99.73%);
}

.t1{
    position: absolute;
    width: 808px;
    height: 112px;
    top: 201px;
    left: 105px;
    font-style: normal;
    font-weight: normal;
    font-size: 45px;
    line-height: 48px;
    letter-spacing: 1.2px;
    color: #FFFFFF;
}
.t2{
    position: absolute;
    width: 788px;
    height: 112px;
    top: 330px;
    left: 105px;
    font-style: normal;
    font-weight: normal;
    font-size: 30px;
    line-height: 32px;
    letter-spacing: 1.1px;
    color: #F2F2F2;
}
.loja1{
    position: absolute;
    width: 114px;
    top: 458px;
    left: 105px;
}
.loja2{
    position: absolute;
    width: 128px;
    left: 235px;
    top: 458px;
}
.celular{
  position: absolute;
  width: 310px;
  left: 895px;
  top: 125px;
}

@media screen and (max-width: 1365px) {
    .celular{
        width: 22.7vw;
        left: 65.5vw;
    }

    .t1{
        width: 54.4vw;
        height: 112px;
        top: 14.7vw;
        left: 7.5vw;
        font-size: 3.3vw;
        line-height: 3.55vw;
        letter-spacing: 1.2px;
    }
    .bg-verde{
        height: 45.4vw;
    }
    .t2{
        width: 56.3vw;
        height: 112px;
        top: 24.2vw;
        left: 7.5vw;
        font-size: 2.2vw;
        line-height: 2.4vw;
    }
    .loja1{
        top: 33.56vw;
        left: 7.5vw;
    }
    .loja2{
        top: 33.56vw;
        //left: 17.0vw;
    }
}

@media screen and (max-width: 1116px) {
    .conteudo{
        max-width: 870px;
    }
    .celular{
        width: 250px;
        left: 640px;
    }
    .bg-verde{
        height: 507px;
    }
    .t1{
        width: 608px;

        height: 112px;
        top: 165px;
        left: 0;
        font-size: 36.8px;
        line-height: 39px;
        letter-spacing: 1.2px;
    }

    .t2{
        width: 630px;
        height: 112px;
        top: 270px;
        left: 0;
        font-size: 24.54px;
        line-height: 26px;
    }
    .loja1{
        top: 374px;
        left: 0;
    }
    .loja2{
        top: 374px;
        left: 140px;
    }
}

@media screen and (max-width: 910px) {
    .celular{
        display: none;
    }
    .conteudo{
        max-width: 615px;
    }
    .t1{
        top: 100px;
    }

    .t2{
        top: 200px;
    }
    .loja1{
        top: 300px;
    }
    .loja2{
        top: 300px;
    }
    .bg-verde{
        height: 420px;
    }
}

@media screen and (max-width: 767px) {
    .bg-verde{
        height: 444px;
    }

    .conteudo{
        max-width: 360px;
    }
    .t1{
        width: 382px;
        left: 0;
        top: 90px;
        font-size: 32px;
        line-height: 36px;
        text-align: center;
    }

    .t2{
        width: 382px;
        height: 128px;
        left: 0;
        top: 223px;
        font-size: 20px;
        line-height: 32px;
        text-align: center;
    }
    .loja1{
        top: 370px;
        left: 55px;
    }
    .loja2{
        top: 370px;
        left: 195px;
    }
}

@media screen and (max-width: 450px) {
    .bg-verde{
        height: 444px;
    }

    //.conteudo{
    //    max-width: 380px;
    //}
    .t1{
        width: 352px;
        left: 0;
        top: 90px;
        font-size: 28px;
        line-height: 33px;
        text-align: center;
    }

    .t2{
        width: 352px;
        height: 128px;
        left: 0;
        top: 203px;
        font-size: 18px;
        line-height: 28px;
        text-align: center;
    }
    .loja1{
        top: 350px;
        left: 35px;
    }
    .loja2{
        top: 350px;
        left: 175px;
    }
}

</style>
